export default __webpack_public_path__ + "static/media/auth.67abdc04.svg";